/* 🤖 this file was generated by svg-to-ts */
export const mgcIconDropFilled: {
  name: 'drop-filled';
  data: string;
} = {
  name: 'drop-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M11.774 2.081a1.53 1.53 0 0 0-.323.113c-.39.199-2.256 1.963-3.242 3.066-4.016 4.49-5.16 8.619-3.391 12.24a7.99 7.99 0 0 0 8.83 4.322c3.076-.638 5.536-3.098 6.174-6.174.41-1.977.076-3.948-1.04-6.148-.935-1.842-2.308-3.63-4.288-5.582-.974-.959-1.712-1.602-1.994-1.736a1.181 1.181 0 0 0-.726-.101"/></svg>`
};
